module.exports = __webpack_public_path__ + "img/img-01--mobile.f8facaf8.jpg";